import * as React from 'react';
import { Link as Template, LinkProps, Box } from '@theme-ui/components';

type Props = {
  disabled?: boolean;
};

const Link = React.forwardRef<HTMLAnchorElement, LinkProps & Props>(
  ({ disabled, ...props }, ref) => {
    return disabled ? (
      <Template as="div" {...props} ref={ref} />
    ) : (
      <Template target="_top" rel="noreferrer noopener" {...props} ref={ref} />
    );
  }
);

export { Link };
export type { LinkProps };

export const ButtonLink = React.forwardRef<HTMLAnchorElement, LinkProps & Props>(
  function ButtonLink(props, ref) {
    return (
      <Box
        ref={ref as any}
        as="a"
        target="_top"
        rel="noreferrer noopener"
        variant="primary"
        {...props}
        // @ts-expect-error
        __themeKey="buttons"
        __css={{
          appearance: 'none',
          display: props.hidden ? undefined : 'inline-block',
          textAlign: 'center',
          lineHeight: 'inherit',
          textDecoration: 'none',
          fontSize: 'inherit',
          px: 3,
          py: 2,
          color: 'white',
          bg: 'primary',
          border: 0,
          borderRadius: 4
        }}
      />
    );
  }
);
